export default "__VITE_ASSET__Bkw7RK2X__"